import { render, staticRenderFns } from "./SLATab.vue?vue&type=template&id=5e871b66&"
import script from "./SLATab.vue?vue&type=script&lang=js&"
export * from "./SLATab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports